import { render, staticRenderFns } from "./UrnCompartmentPlaqueEngraving.vue?vue&type=template&id=db6430c0&scoped=true&"
import script from "./UrnCompartmentPlaqueEngraving.vue?vue&type=script&lang=js&"
export * from "./UrnCompartmentPlaqueEngraving.vue?vue&type=script&lang=js&"
import style0 from "./UrnCompartmentPlaqueEngraving.vue?vue&type=style&index=0&id=db6430c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6430c0",
  null
  
)

export default component.exports